import React, { Suspense } from 'react';
import Container from '../components/Container';
import StickyHeader from '../components/StickyHeader';
import Header from '../components/Header';
import { Modal, Radio, RadioChangeEvent } from 'antd';
import { PrinterType } from '~/types/printer';
import PrinterWifi from './components/PrinterWifi';
import PrinterBluetooth from './components/PrinterBluetooth';
import { usePrinter } from '~/App/Layout/providers/PrinterProviderV2';
import TestPrintButton from './components/TestPrintButton';
import Loading from '../components/Loading';
import ErrorBoundary from '../ErrorBoundary';

const { confirm } = Modal;

const PrinterV2 = () => {
  const { settings, saveSettings, bluetooth } = usePrinter();

  const onChange = (e: RadioChangeEvent) => {
    confirm({
      title: 'Yakin ganti tipe printer?',
      onOk: () => {
        if (settings.type === PrinterType.Bluetooth) {
          bluetooth.disconnect();
        }
        saveSettings({ type: e.target.value as PrinterType });
      },
      maskClosable: true,
      closable: true,
    });
  };

  return (
    <Container>
      <StickyHeader>
        <Header title="Setup Printer" />
      </StickyHeader>
      <div className="p-6 flex flex-col gap-6">
        <Radio.Group
          buttonStyle="solid"
          onChange={onChange}
          value={settings.type}
          className="w-full flex"
          size="large"
        >
          <Radio.Button
            value={PrinterType.Bluetooth}
            className="w-1/2 text-center"
          >
            Bluetooth
          </Radio.Button>
          <Radio.Button value={PrinterType.Wifi} className="w-1/2 text-center">
            Wi-Fi
          </Radio.Button>
        </Radio.Group>
        {settings.type === PrinterType.Wifi ? (
          <ErrorBoundary>
            <Suspense fallback={<Loading />}>
              <PrinterWifi />
            </Suspense>
          </ErrorBoundary>
        ) : (
          <PrinterBluetooth />
        )}
        <TestPrintButton />
      </div>
    </Container>
  );
};

export default PrinterV2;
